import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  size = "base",
}) => {
  const baseSize = "h-6 w-4 md:h-8 md:w-8 text-xs ";

  const getPageNumbers = () => {
    const pages = [];
    const totalVisiblePages = 5;

    if (totalPages <= totalVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  };

  const handleJumpBack = () => {
    onPageChange(Math.max(currentPage - 2, 1));
  };

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handleJumpForward = () => {
    onPageChange(Math.min(currentPage + 2, totalPages));
  };

  return (
    <nav aria-label="Page navigation">
      <ul className="flex items-center md:gap-3 h-8 text-base">
        {/* Double Left */}
        {/* <li>
              <button
                onClick={handleJumpBack}
                disabled={currentPage <= 2}
                className={`flex items-center justify-center ${baseSize} rounded-full border border-[#F1F1F1] hover:bg-gray-700/10`}
              >
                <ChevronDoubleLeftIcon className="w-[16px] h-[16px] text-white" />
              </button>
            </li> */}

        {/* Single Left */}
        <li>
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className={`flex items-center justify-center !text-sm  bg-transparent hover:bg-transparent`}
          >
            <ChevronLeftIcon className="w-[16px] h-[16px] text-[#697077] md:mr-1" />
            <span className="hidden md:block text-[#697077]">
              &nbsp;Previous
            </span>
          </button>
        </li>

        {/* Page Numbers */}
        {getPageNumbers().map((page, index) => (
          <li key={index}>
            {page === "..." ? (
              <span className="px-2 text-gray-400">...</span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`flex items-center font-semibold justify-center ${baseSize} rounded-lg border border-[#F1F1F1] bg-transparent hover:bg-transparent ${
                  currentPage === page
                    ? "z-10 text-[#001D6C] !bg-[transparent] ring-1 ring-[#DDE1E6]"
                    : "text-[#001D6C] hover:ring-1 ring-[#DDE1E6] "
                }`}
              >
                {page}
              </button>
            )}
          </li>
        ))}

        {/* Single Right */}
        <li>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`flex items-center justify-center !text-sm rounded-full bg-transparent hover:bg-transparent`}
          >
            <span className="hidden md:block text-[#697077]">Next </span>
            <ChevronRightIcon className="w-[16px] h-[16px] text-[#697077] md:ml-1" />
          </button>
        </li>

        {/* Double Right */}
        {/* <li>
              <button
                onClick={handleJumpForward}
                disabled={currentPage >= totalPages - 1}
                className={`flex items-center justify-center ${baseSize} rounded-full border border-[#F1F1F1] hover:bg-gray-700/10`}
              >
                <ChevronDoubleRightIcon className="w-[16px] h-[16px] text-white" />
              </button>
            </li> */}
      </ul>
    </nav>
  );
};

export default Pagination;
